import PropTypes from 'prop-types';
import {useState} from 'react';
import {createUseStyles, useTheme} from 'react-jss';
import PlusIcon from '../../../../../UI/PlusIcon/PlusIcon';
import {SelectableContainer} from '../../../../../UI/SelectableContainer/SelectableContainer';
import BillingAddress from '../../../../../v2/components/address/BillingAddress';
import addressBookIcon
from '../../../../../v2/components/address/DefaultAddress/DefaultAddressLogos/address_book_icon.svg';
import Translation from '../../../../../v2/lang/Translation';
import Spacing from '../../../../../v2/style-helper/Spacing';
import BillingAddressSelectionField from '../SavedBillingAddresses/BillingAddressSelectionField';

const useStyles = createUseStyles({
  button: {
    background: 'none',
    border: 'none',
    textAlign: 'left',
    width: '100%',
    padding: [0, 0, 0, 0],
    marginBottom: 0,
    display: 'flex',
    lineHeight: 'inherit',
  },
  
  billingAddress: {
    margin: [Spacing.triple, 0, Spacing.single],
  },
  
  billingAddressContainerTitle: {
    fontWeight: 'bold',
  },
  
  billingAddressContainerSubTitle: {
    fontWeight: 'bold',
    marginBottom: 0,
  },
  
  billingAddressContainerCondensed: {
    fontWeight: 'bold',
    marginBottom: 0,
  },
  
  icon: {
    float: 'left',
    marginRight: 6,
    height: [Spacing.triple],
    width: [Spacing.triple],

  },
  
  selectSavedAddNewSelection: {
    marginTop: [Spacing.double],
    marginBottom: [Spacing.double],
  },
  
  savedAddressDropdown: {
    display: 'flex',
  },
});

export function ExpandingBillingAddressLayout(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const [savedAddressExpanded, setSavedAddressExpanded] = useState(props.savedAddressExists);
  const [newAddressExpanded, setNewAddressExpanded] = useState(!props.savedAddressExists);
  
  function handleSavedAddressClick() {
    if (!savedAddressExpanded) {
      setSavedAddressExpanded(true);
      setNewAddressExpanded(false);
    }
  }
  function handleNewAddressClick() {
    if (!newAddressExpanded) {
      setSavedAddressExpanded(false);
      setNewAddressExpanded(true);
    }
  }
  
  return (
    <div className={classes.billingAddress}>
      <div className={classes.billingAddressContainerTitle}>
        <Translation>checkout.billing.savedAddressLayout</Translation>
      </div>
      <div className={classes.selectSavedAddNewSelection}>
        <SelectableContainer
          isSelected
          noBorder={savedAddressExpanded}
          noShadow
          noBoxShadow
          hideIcon
          noPadding={savedAddressExpanded}
          alternativeBillingLayout
        >
          <button
            className={classes.button}
            onClick={handleSavedAddressClick}
            type="button"
          >
            {savedAddressExpanded ? (
              <span>
                <div className={classes.billingAddressContainerSubTitle} data-test="BillingAddressForm__savedExpanded">
                  <Translation>checkout.billing.savedAddressLayout.yourSavedAddress</Translation>
                </div>
                <BillingAddressSelectionField className={classes.savedAddressDropdown} />
              </span>
            ) : (
              <span className={classes.billingAddressContainerCondensed}>
                <span className={classes.icon}>
                  <img src={addressBookIcon} alt="" />
                </span>
                <Translation>checkout.billing.savedAddressLayout.useSavedAddress</Translation>
              </span>
            )}
          </button>
        </SelectableContainer>
      </div>
      <div className={classes.selectSavedAddNewSelection}>
        <SelectableContainer
          noBorder={newAddressExpanded}
          noShadow
          noBoxShadow
          hideIcon
          noPadding={newAddressExpanded}
          alternativeBillingLayout
        >
          <button
            data-test="BillingNewAddressList__expandButton"
            className={classes.button}
            onClick={handleNewAddressClick}
            type="button"
          >
            {newAddressExpanded ? (
              <div className={classes.billingAddress} data-test="BillingAddressForm__newExpanded">
                <div className={classes.billingAddressContainerSubTitle}>
                  <Translation>checkout.billing.savedAddressLayout.addNewAddress</Translation>
                </div>
                <BillingAddress
                  showForm={props.showBillingAddressForm}
                />
              </div>
            ) : (
              <span className={classes.billingAddressContainerCondensed}>
                <span className={classes.icon}><PlusIcon /></span>
                <Translation>checkout.billing.savedAddressLayout.addNewAddress</Translation>
              </span>
            )}
          </button>
        </SelectableContainer>
      </div>
    </div>
  );
}

ExpandingBillingAddressLayout.propTypes = {
  showBillingAddressForm: PropTypes.bool.isRequired,
  savedAddressExists: PropTypes.bool,
};

export default ExpandingBillingAddressLayout;
